<template>
  <svg
    width="196"
    height="144"
    viewBox="0 0 196 144"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="196" height="144" fill="white" />
    <path
      opacity="0.8"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M159 73C159 107.242 131.242 135 97 135C62.7583 135 35 107.242 35 73C35 38.7583 62.7583 11 97 11C131.242 11 159 38.7583 159 73ZM53 20C53 24.9706 48.9706 29 44 29C39.0294 29 35 24.9706 35 20C35 15.0294 39.0294 11 44 11C48.9706 11 53 15.0294 53 20ZM171.5 65C173.985 65 176 62.9853 176 60.5C176 58.0147 173.985 56 171.5 56C169.015 56 167 58.0147 167 60.5C167 62.9853 169.015 65 171.5 65Z"
      fill="url(#paint0_radial_651_11479)"
    />
    <path
      d="M51.9134 93.7532C52.876 95.7416 55.2682 96.5732 57.2566 95.6107L119.363 65.5471C121.351 64.5846 122.183 62.1924 121.22 60.2039L116.537 50.5298C115.928 49.2714 114.706 48.4224 113.314 48.2905L68.3662 44.0313C66.7294 43.8762 65.1645 44.7385 64.4211 46.2049L47.1454 80.2844C46.5808 81.3982 46.5687 82.7118 47.1128 83.8358L51.9134 93.7532Z"
      fill="url(#paint1_radial_651_11479)"
    />
    <path
      d="M64 32C64 29.7909 65.7909 28 68 28H125.118C126.31 28 127.44 28.5315 128.2 29.4497L135.082 37.7652C135.675 38.4825 136 39.3844 136 40.3155V111C136 113.209 134.209 115 132 115H68C65.7909 115 64 113.209 64 111V32Z"
      fill="url(#paint2_radial_651_11479)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M97 48C98.1046 48 99 47.1046 99 46V45C99 43.8954 98.1046 43 97 43L71 43C69.8954 43 69 43.8954 69 45V46C69 47.1046 69.8954 48 71 48L97 48ZM107 57C108.105 57 109 56.1046 109 55V54C109 52.8954 108.105 52 107 52L90 52C88.8954 52 88 52.8954 88 54V55C88 56.1046 88.8954 57 90 57L107 57ZM85 55C85 56.1046 84.1046 57 83 57L71 57C69.8954 57 69 56.1046 69 55V54C69 52.8954 69.8954 52 71 52L83 52C84.1046 52 85 52.8954 85 54V55ZM129.5 65.5H130V63C130 61.8954 129.105 61 128 61H125.964V61.5V62H128C128.552 62 129 62.4477 129 63V65.5H129.5ZM129.5 70.5H130V73C130 74.1046 129.105 75 128 75H125.964V74.5V74H128C128.552 74 129 73.5523 129 73V70.5H129.5ZM121.893 74.5V75H117.821V74.5V74L121.893 74V74.5ZM113.75 74.5V75H109.679L109.679 74.5V74H113.75V74.5ZM105.607 74.5V75H101.536V74.5V74H105.607V74.5ZM97.4643 74.5V75H93.3929V74.5V74L97.4643 74V74.5ZM89.3214 74.5V75H85.25V74.5V74H89.3214V74.5ZM81.1786 74.5V75H77.1071V74.5V74H81.1786V74.5ZM73.0357 74.5V75H71C69.8954 75 69 74.1046 69 73V70.5H69.5H70L70 73C70 73.5523 70.4477 74 71 74H73.0357V74.5ZM69.5 65.5H69V63C69 61.8954 69.8954 61 71 61H73.0357L73.0357 61.5V62H71C70.4477 62 70 62.4477 70 63L70 65.5H69.5ZM77.1071 61.5V61H81.1786V61.5V62H77.1071V61.5ZM85.25 61.5V61H89.3214V61.5V62H85.25V61.5ZM93.3929 61.5V61L97.4643 61V61.5V62L93.3929 62V61.5ZM101.536 61.5V61H105.607V61.5V62H101.536V61.5ZM109.679 61.5V61H113.75V61.5V62H109.679V61.5ZM117.821 61.5V61L121.893 61V61.5V62L117.821 62V61.5ZM129.5 81.75H130V80C130 78.8954 129.105 78 128 78H125.964V78.5V79H128C128.552 79 129 79.4477 129 80V81.75H129.5ZM129.5 85.25H130L130 88.75H129.5H129L129 85.25H129.5ZM129.5 92.25H130V95.75H129.5H129V92.25H129.5ZM129.5 99.25H130V102.75H129.5H129V99.25H129.5ZM129.5 106.25H130V108C130 109.105 129.105 110 128 110H125.964V109.5V109H128C128.552 109 129 108.552 129 108V106.25H129.5ZM121.893 109.5V110H117.821V109.5V109H121.893V109.5ZM113.75 109.5V110H109.679V109.5V109H113.75V109.5ZM105.607 109.5L105.607 110H101.536V109.5V109H105.607V109.5ZM97.4643 109.5V110H93.3929V109.5V109H97.4643V109.5ZM89.3214 109.5V110L85.25 110V109.5V109L89.3214 109V109.5ZM81.1786 109.5V110H77.1072V109.5V109H81.1786V109.5ZM73.0357 109.5V110H71C69.8954 110 69 109.105 69 108L69 106.25H69.5H70L70 108C70 108.552 70.4477 109 71 109H73.0357V109.5ZM69.5 102.75H69L69 99.25H69.5H70L70 102.75H69.5ZM69.5 95.75H69L69 92.25H69.5H70L70 95.75H69.5ZM69.5 88.75H69L69 85.25H69.5H70L70 88.75H69.5ZM69.5 81.75H69V80C69 78.8954 69.8954 78 71 78H73.0357V78.5V79H71C70.4477 79 70 79.4477 70 80L70 81.75H69.5ZM77.1071 78.5V78H81.1786V78.5V79H77.1071V78.5ZM85.25 78.5V78H89.3214V78.5V79H85.25V78.5ZM93.3929 78.5V78H97.4643V78.5V79H93.3929V78.5ZM101.536 78.5V78H105.607V78.5V79H101.536V78.5ZM109.679 78.5V78H113.75V78.5V79H109.679V78.5ZM117.821 78.5V78H121.893V78.5V79H117.821V78.5ZM130 55C130 56.1046 129.105 57 128 57L115 57C113.895 57 113 56.1046 113 55V54C113 52.8954 113.895 52 115 52L128 52C129.105 52 130 52.8954 130 54V55Z"
      fill="url(#paint3_radial_651_11479)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_651_11479"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(152 -25.5) rotate(115.438) scale(193.234 193.234)"
      >
        <stop stop-color="#EAEEF9" />
        <stop offset="1" stop-color="#A3B1D1" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_651_11479"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(82.2243 66.8598) rotate(-114.424) scale(81.5245 146.756)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="0.99407" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_651_11479"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(153.5 135.5) rotate(-129.519) scale(140.65 154.02)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_651_11479"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(75 72) rotate(27.1351) scale(89.8944 98.7809)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
    </defs>
  </svg>
</template>
